/** API route map: URLS.Controller.CandidateTask */
export const CandidateTask = {
      Name: 'CandidateTask/',
      GetAllTask: 'candidate-task',
      AddTask: 'add',
      UpdateTask: 'update',
      DeleteTask: 'delete',
      PatchTaskStatus: 'patch-task-status',
};
